import { AppData, AppDataLocalTax } from '@scts/app-data';
import {
  ContactSg,
  PageHeader,
  PageHeaderSg,
} from '@scts-ui/component-library';
import './contact.scss';
import { useTitleService } from '@scts/utilities';

export const Contact = () => {
  useTitleService('Contact Us: Social Security Chamber');
  return (
    <div className="contact-wrapper">
      <PageHeaderSg headerText={'Contact Us'} />
      <ContactSg
        address={AppData.contact.address}
        orginisationName={AppData.contact.orginisationName}
        email={AppData.contact.email}
        phone={AppData.contact.phone}
        phoneText={AppData.contact.phoneText}
        publicHolidayLink={AppData.contact.publicHolidayLink}
        publicHolidayText={AppData.contact.publicHolidayText}
        complaints={AppDataLocalTax.contact.complaints}
      />
    </div>
  );
};

export default Contact;
